import { render, staticRenderFns } from "./TaskSettingsAttachments.vue?vue&type=template&id=57ffe9d6&"
import script from "./TaskSettingsAttachments.vue?vue&type=script&lang=js&"
export * from "./TaskSettingsAttachments.vue?vue&type=script&lang=js&"
import style0 from "./TaskSettingsAttachments.vue?vue&type=style&index=0&module=true&lang=less&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./TaskSettingsAttachments.vue?vue&type=style&index=0&module=true&lang=less&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./TaskSettingsAttachments.vue?vue&type=style&index=0&module=true&lang=less&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("57ffe9d6")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ffe9d6')) {
      api.createRecord('57ffe9d6', component.options)
    } else {
      api.reload('57ffe9d6', component.options)
    }
    module.hot.accept("./TaskSettingsAttachments.vue?vue&type=template&id=57ffe9d6&", function () {
      api.rerender('57ffe9d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/taskSettings/sections/attachments/TaskSettingsAttachments.vue"
export default component.exports